import React from "react";
import { Button, Label } from "reactstrap";
import { formatDate, formatRP } from "../../../Utils/externalFunctions";
import { useNavigate } from "react-router-dom";
import DataTableTitle from "../../DataTableComponents/DataTableTitle";
import DataTable from "react-data-table-component";
import { useThemeContext } from "../../../Context/ThemeContext";
import DateSortFunction from "../../DataTableComponents/DateSortFunction";

const StepTiga = ({ formGroupTransaksi, transaksiList, handlePrev }) => {
  const navigate = useNavigate();

  const { themeContext } = useThemeContext();

  const DaftarColumns = [
    {
      name: <DataTableTitle text={"Kode Transaksi"} />,
      selector: (row) => row.id_transaksi,
      sortable: true,
      wrap: true,
    },
    {
      name: <DataTableTitle text={"Diajukan Oleh"} />,
      selector: (row) => row.diajukan_oleh,
      sortable: true,
    },
    {
      name: <DataTableTitle text={"DPSJ"} />,
      selector: (row) => row.id_unit_kerja,
      sortable: true,
      wrap: true,
    },
    {
      name: <DataTableTitle text={"Tanggal Transaksi"} />,
      selector: (row) => formatDate(row.tanggal_transaksi),
      sortable: true,
      sortFunction: DateSortFunction("tanggal_transaksi"),
    },
    {
      name: <DataTableTitle text={"Keterangan"} />,
      selector: (row) => row.keterangan,
      sortable: true,
      wrap: true,
    },
    {
      name: <DataTableTitle text={"Dibayar Ke"} />,
      selector: (row) => row.dibayarkan_ke,
      sortable: true,
    },
    {
      name: <DataTableTitle text={"Diperlukan (Rp)"} />,
      selector: (row) => parseInt(row.nilai_transaksi),
      sortable: true,
      format: (row) => formatRP(row.nilai_transaksi),
    },
    {
      // name: <DataTableTitle text={"Operasi"} />,
    },
  ];

  return (
    <>
      <Label className="bg-transparent">Transaksi yang digrupkan</Label>
      <DataTable
        columns={DaftarColumns}
        data={transaksiList}
        pagination
        selectableRowsHighlight
        highlightOnHover
        persistTableHead
        theme={themeContext}
      />
      <div className="row justify-content-center mt-4">
        <div className="col-auto">
          <Button disabled>Submit</Button>
        </div>
        <div className="col-auto">
          <Button
            color="primary"
            variant="contained"
            onClick={() => {
              window.open(
                `${process.env.PUBLIC_URL}/groupdokumentransaksi/document/${formGroupTransaksi.id}`,
                "_blank"
              );
              navigate(`${process.env.PUBLIC_URL}/transaksi/`);
            }}
          >
            Cetak
          </Button>
        </div>
      </div>
    </>
  );
};

export default StepTiga;
